<template>
  <v-container class="fill-height" id="mainhomecontainer">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="10">
        <v-card class="elevation-4">
          <v-card-text>
            <h1 class="display-1" justify="center" align="center">Dashboard</h1>
            <v-divider></v-divider>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="6" md="4">
                <v-hover v-slot:default="{ hover }">
                  <v-card color="#385F73" dark :elevation="hover ? 12 : 2">
                    <v-card-text class="white--text">
                      <div class="headline mb-2">Businesses</div>Create and Manage Businesses
                    </v-card-text>
                    <v-card-actions>
                      <v-btn text @click="$router.push('/agent/businesslist')">Business List</v-btn> <v-btn text @click="$router.push('/agent/createbusiness')">Add Business</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-hover>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-hover v-slot:default="{ hover }">
                  <v-card color="primary" dark :elevation="hover ? 12 : 2">
                    <v-card-text class="white--text">
                      <div class="headline mb-2">Profile</div>Manage Your Profile
                    </v-card-text>

                    <v-card-actions>
                      <v-btn text @click="$router.push('/agent/editprofile/'+agentid)">Edit Profile</v-btn> <v-btn text @click="$router.push('/agent/changepassword')">Change Password</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-hover>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-hover v-slot:default="{ hover }">
                  <v-card color="primary" dark :elevation="hover ? 12 : 2">
                    <v-card-text class="white--text">
                      <div class="headline mb-2">Reports</div>Agents, Tags and Business Reports
                    </v-card-text>

                    <v-card-actions>
                      <v-btn text>Manage Reports</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-hover>
              </v-col>
              
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script scoped>
export default {
  props: {
    source: String
  },
  data: () => ({
  agentid:""
  }),
  created() {
   let user = JSON.parse(localStorage.getItem("user") || "{}");
    if (Object.keys(user).length !== 0) 
    {
              if (user.userType == "agent") 
              {
                this.agentid=user.id;
              }
    }    
  },
  methods:{

  }

 
};
</script>

<style>

  #mainhomecontainer.container {
    width: 100%;
    max-width: 100%;
  }
  #mainhomecontainer.container .heading {
    color: #fff;
  }

</style>